export default "__VITE_ASSET__09cd7dfe__"